import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=4d540c64&scoped=true&lang=pug"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d540c64",
  null
  
)

export default component.exports